<template>
  <div class="meta-navigation">
    <span v-show="isScrollableLeft" class="meta-navigation__left-shadow" />
    <ul ref="scrollList" class="meta-navigation__list">
      <li v-for="(item, i) of links" :key="i" class="meta-navigation__item">
        <a class="meta-navigation__link" :href="item.href">{{ item.title }}</a>
      </li>
    </ul>
    <span v-show="isScrollableRight" class="meta-navigation__right-shadow" />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'MagazineMetaNavigation',

  props: {
    links: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      scrollList: null,
      isScrollableLeft: false,
      isScrollableRight: false,
    }
  },

  async created() {
    window.addEventListener('resize', this.updateNavigationVisibility)
  },
  async mounted() {
    this.scrollList = this.$refs.scrollList
    this.scrollList.addEventListener(
      'scroll',
      debounce(this.updateNavigationVisibility, 10),
    )
    /* Next tick and timeout needed to show the shadow initially */
    await this.$nextTick()
    setTimeout(() => {
      this.updateNavigationVisibility()
    }, 50)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateNavigationVisibility)
    this.scrollList.removeEventListener(
      'scroll',
      debounce(this.updateNavigationVisibility, 10),
    )
  },
  methods: {
    updateNavigationVisibility() {
      const isScrollable =
        this.scrollList.scrollWidth > this.scrollList.clientWidth
      if (isScrollable) {
        this.isScrollableRight =
          Math.round(this.scrollList.scrollLeft + this.scrollList.offsetWidth) <
          this.scrollList.scrollWidth
        this.isScrollableLeft = this.scrollList.scrollLeft > 0
      } else {
        this.isScrollableLeft = this.isScrollableRight = false
      }
    },
  },
}
</script>

<style>
.meta-navigation {
  position: relative;
  /* To prevent overflowing of the meta-area-content */
  min-width: 0;
}

.meta-navigation__list {
  display: flex;
  gap: var(--spacing-4);
  list-style: none;
  width: 100%;
  overflow: auto;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
}

.meta-navigation__right-shadow,
.meta-navigation__left-shadow {
  position: absolute;
  top: 0;
  z-index: 2;
  height: 100%;
  width: 46px;
  background: linear-gradient(
    to left,
    white,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.5) 85%,
    rgba(255, 255, 255, 0.1) 100%
  );
  cursor: pointer;
  pointer-events: none;

  /* reset */
  appearance: none;
  border: none;
}

.meta-navigation__right-shadow {
  right: 0;
}

.meta-navigation__left-shadow {
  left: 0;
  transform: rotate(180deg);
}

.meta-navigation__item {
  white-space: nowrap;
}

.meta-navigation__link {
  font-size: 12px;
  font-weight: 400;
  color: var(--c-primary-neutral-1);

  &:hover {
    border-bottom: none;
  }
}

@media (--xs) {
  .meta-navigation__link {
    font-size: 16px;
  }
}

@media (--lg) {
  .meta-navigation {
    display: none;
  }
}
</style>
